module.exports = __webpack_public_path__ + "media/icons/pdf@2x-d42cb446.png";